import services from './module';
import {Strings} from 'Strings';
import {HttpSvcFactory} from './HttpSvc';
import {AnimatronPreviews} from './AnimatronPreviewsSvc';
import {AnimatronSvc} from 'services/AnimatronSvc';
import {ProjectAugmenter} from './ProjectAugmenter';

export const PROJECT_ADD = 'anm:project:add';

export class AnimatronProjects extends AnimatronSvc<anm.Project> {
    AnimatronPreviews: AnimatronPreviews;
    ProjectAugmenter: ProjectAugmenter;

    public static computedWidth = 290;

    searchWord?: string;
    projectsAuthor?: anm.User;

    results: Array<anm.Project>;
    pages: Array<Array<anm.Project>>;
    computedWidth                = AnimatronProjects.computedWidth;
    uniqueId: string             = 'id';
    query: ProjectSearchCriteria = Object.assign({
        sortOrder: 'desc' as 'desc' | 'asc',
        sortBy: 'modification_time',
        withTags: true,
        withCollaborators: true,
        withBackendUrl: true,
        withDuplicatesCount: true,
        withComments: true,
        withLikes: true
    }, this.query);

    protected modifyQuery(query: ProjectSearchCriteria) {
        query.previewWidth = options.handHeld ? 720 : 320;
        if (options.retina) query.previewWidth *= 2;
        super.modifyQuery(query);
    }

    protected makeHttpSvc(secure: boolean, api = '') {
        const svc = this.HttpSvc('project/list');
        if (!Strings.isBlank(api)) {
            svc.setApiUrl(api);
        }
        this.foreignAccess = !api && options.user.rolez.ForeignProjectPermissions && options.user.rolez.ForeignProjectPermissions.list;
        return svc[secure || this.foreignAccess ? 'secureGet' : 'get'];
    }

    onCreate() {
        this.$rootScope.$on('project:remove', (e, pid) => this.removeProject(pid));
        this.$rootScope.$on(PROJECT_ADD, (e, {project}) => this.addProject(project));
    }

    addProject(project: anm.Project) {
        if (this.results.some(p => p.id === project.id)) return;

        this.pages[1] && this.pages[1].push(project);
        this.reorderPages();
        this.results.push(project);
        this.count++;
        this.decorate(this.results);
    }

    removeProject(pid: string) {
        const currentCount = this.results.length;
        this.pages         = this.pages.map(page => page.filter(p => p.id !== pid));
        this.results       = this.results.filter(p => p.id !== pid);
        this.count         = this.count - (currentCount - this.results.length);
    }

    decorate(results: Array<anm.Project>) {
        results.forEach((project: anm.Project) => {
            project.computedHeight = this.AnimatronPreviews.computeHeight(project.height, project.width, this.computedWidth);
            this.ProjectAugmenter(project);
        });
    }
}

export type AnimatronProjectsFactory = typeof AnimatronProjects;

services.factory('AnimatronProjects', ($rootScope: ng.IRootScopeService,
                                       $log: ng.ILogService,
                                       $timeout: ng.ITimeoutService,
                                       $q: ng.IQService,
                                       $stateParams: any,
                                       HttpSvc: HttpSvcFactory,
                                       AnimatronPreviews: AnimatronPreviews,
                                       ProjectAugmenter: ProjectAugmenter) => {
    _.extend(AnimatronProjects.prototype, {
        $rootScope, $log, $timeout, $q, $stateParams, HttpSvc, AnimatronPreviews, ProjectAugmenter
    });
    return AnimatronProjects;
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AnimatronProjectsSvc.ts